import { useState, useEffect } from "react";
import { api } from "../../context";

export default function Users({ t }) {
  const [users, setUsers] = useState({ data: [], current_page: 1, last_page: 1, total: 0 });
  const [search, setSearch] = useState("");
  const [input, setInput] = useState("");
  const [flash, setFlash] = useState("");

  const showFlash = (msg) => { setFlash(msg); setTimeout(() => setFlash(""), 3000); };

  const load = async (page = 1, s = search) => {
    const q = s ? `?page=${page}&search=${s}` : `?page=${page}`;
    const r = await api(`/admin/users${q}`);
    if (r.ok) setUsers(r.data);
  };

  useEffect(() => { load(1); }, []);

  const changePlan = async (userId, plan) => {
    const r = await api(`/admin/users/${userId}/plan`, { method: "POST", body: JSON.stringify({ plan }) });
    if (r.ok) { showFlash("Plan updated ✓"); load(users.current_page); }
  };

  const banUser = async (u) => {
    const r = await api(`/admin/users/${u.id}/ban`, { method: "POST", body: JSON.stringify({ reason: "Admin action" }) });
    if (r.ok) { showFlash(`${u.name} banned`); load(users.current_page); }
  };

  const unbanUser = async (u) => {
    const r = await api(`/admin/users/${u.id}/unban`, { method: "POST" });
    if (r.ok) { showFlash(`${u.name} unbanned`); load(users.current_page); }
  };

  const resetPw = async (u) => {
    const pw = prompt(`New password for ${u.name} (min 6 chars):`);
    if (pw && pw.length >= 6) {
      const r = await api(`/admin/users/${u.id}/reset-password`, { method: "POST", body: JSON.stringify({ password: pw }) });
      if (r.ok) showFlash("Password reset ✓");
    }
  };

  const CARD = t.card, BORDER = t.border, TEXT = t.text, SUB = t.sub;
  const PRI = t.pri, GRN = t.grn, RED = t.red, GOLD = t.gold;

  return (
    <div>
      {flash && <div style={{ position: "fixed", top: 20, right: 20, background: GRN, color: "#fff", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, zIndex: 9999 }}>{flash}</div>}

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>All Users</div>
          <div style={{ fontSize: 12, color: SUB, marginTop: 4 }}>{users.total} total members</div>
        </div>
        <form onSubmit={e => { e.preventDefault(); setSearch(input); load(1, input); }} style={{ display: "flex", gap: 8 }}>
          <input value={input} onChange={e => setInput(e.target.value)} placeholder="Search name or email..."
            style={{ padding: "10px 16px", borderRadius: 10, border: `1px solid ${BORDER}`, background: t.input, color: TEXT, fontSize: 13, outline: "none", width: 260 }} />
          <button type="submit" style={{ padding: "10px 20px", borderRadius: 10, border: "none", background: PRI, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Search</button>
          {search && <button type="button" onClick={() => { setSearch(""); setInput(""); load(1, ""); }} style={{ padding: "10px 16px", borderRadius: 10, border: `1px solid ${BORDER}`, background: "transparent", color: SUB, fontSize: 13, cursor: "pointer" }}>Clear</button>}
        </form>
      </div>

      {/* Stats row */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
        {[
          { label: "Total", value: users.total, color: PRI },
          { label: "Premium", value: (users.data || []).filter(u => u.plan === "premium").length + " on page", color: GRN },
          { label: "Elite", value: (users.data || []).filter(u => u.plan === "elite").length + " on page", color: GOLD },
          { label: "Banned", value: (users.data || []).filter(u => u.is_banned).length + " on page", color: RED },
        ].map((s, i) => (
          <div key={i} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 12, padding: "14px 18px" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>{s.label}</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden" }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: t.hover, borderBottom: `2px solid ${BORDER}` }}>
                {["User", "Email", "Plan", "Gender", "Orientation", "Age", "Location", "Trust", "Posts", "Joined", "Status", "Actions"].map(h => (
                  <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(users.data || []).map((u, i, arr) => (
                <tr key={u.id} style={{ borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none", background: u.is_banned ? `${RED}08` : i % 2 === 0 ? "transparent" : `${BORDER}20` }}>
                  <td style={{ padding: "12px 14px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      {u.avatar_url
                        ? <img src={u.avatar_url} style={{ width: 34, height: 34, borderRadius: 17, objectFit: "cover" }} alt="" />
                        : <div style={{ width: 34, height: 34, borderRadius: 17, background: `linear-gradient(135deg, ${PRI}, #a23ad1)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>{u.avatar_emoji || "👤"}</div>
                      }
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: TEXT }}>{u.name}</div>
                        <div style={{ fontSize: 10, color: SUB }}>#{u.id}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "12px 14px", fontSize: 12, color: SUB, maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{u.email}</td>
                  <td style={{ padding: "12px 14px" }}>
                    <select value={u.plan || "free"} onChange={e => changePlan(u.id, e.target.value)}
                      style={{ padding: "4px 8px", borderRadius: 8, border: `1px solid ${BORDER}`, background: t.input, color: TEXT, fontSize: 11, fontWeight: 600, outline: "none", cursor: "pointer" }}>
                      <option value="free">Free</option>
                      <option value="premium">Premium</option>
                      <option value="elite">Elite</option>
                    </select>
                  </td>
                  <td style={{ padding: "12px 14px", fontSize: 12, color: SUB }}>{u.gender || "—"}</td>
                  <td style={{ padding: "12px 14px", fontSize: 12, color: SUB }}>{u.orientation || "—"}</td>
                  <td style={{ padding: "12px 14px", fontSize: 12, color: SUB }}>{u.age || "—"}</td>
                  <td style={{ padding: "12px 14px", fontSize: 12, color: SUB }}>{u.location || "—"}</td>
                  <td style={{ padding: "12px 14px", fontSize: 13, fontWeight: 700, color: GOLD }}>{u.trust_score}</td>
                  <td style={{ padding: "12px 14px", fontSize: 12, color: TEXT }}>{u.posts_count || 0}</td>
                  <td style={{ padding: "12px 14px", fontSize: 11, color: SUB, whiteSpace: "nowrap" }}>{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td>
                  <td style={{ padding: "12px 14px" }}>
                    <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: u.is_banned ? `${RED}20` : `${GRN}20`, color: u.is_banned ? RED : GRN }}>
                      {u.is_banned ? "Banned" : "Active"}
                    </span>
                  </td>
                  <td style={{ padding: "12px 14px" }}>
                    <div style={{ display: "flex", gap: 6 }}>
                      <button onClick={() => resetPw(u)} style={{ padding: "5px 10px", borderRadius: 8, border: `1px solid ${BORDER}`, background: "transparent", color: SUB, fontSize: 11, cursor: "pointer" }}>🔑</button>
                      {u.is_banned
                        ? <button onClick={() => unbanUser(u)} style={{ padding: "5px 10px", borderRadius: 8, border: "none", background: `${GRN}20`, color: GRN, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Unban</button>
                        : <button onClick={() => banUser(u)} style={{ padding: "5px 10px", borderRadius: 8, border: "none", background: `${RED}20`, color: RED, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Ban</button>
                      }
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {(users.last_page || 1) > 1 && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "16px", borderTop: `1px solid ${BORDER}` }}>
            <button onClick={() => load(users.current_page - 1)} disabled={users.current_page <= 1}
              style={{ padding: "7px 16px", borderRadius: 9, border: `1px solid ${BORDER}`, background: "transparent", color: TEXT, fontSize: 12, fontWeight: 700, cursor: "pointer", opacity: users.current_page <= 1 ? 0.4 : 1 }}>← Prev</button>
            <span style={{ fontSize: 13, color: SUB }}>Page {users.current_page} of {users.last_page}</span>
            <button onClick={() => load(users.current_page + 1)} disabled={users.current_page >= users.last_page}
              style={{ padding: "7px 16px", borderRadius: 9, border: `1px solid ${BORDER}`, background: "transparent", color: TEXT, fontSize: 12, fontWeight: 700, cursor: "pointer", opacity: users.current_page >= users.last_page ? 0.4 : 1 }}>Next →</button>
          </div>
        )}
      </div>
    </div>
  );
}